import { IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function LibraryBanner({ content, onClose = null, gap = 2 }) {
  if (!content) return null;
  return (
    <Box
      width="100%"
      sx={{
        mb: gap,
        p: { xs: 1, sm: 0.5 },
        display: "flex",
        alignItems: "center",
        gap: 1,
        bgcolor: (theme) => theme.palette.secondary.main,
        borderRadius: 1,
      }}
    >
      {content}
      {onClose && (
        <IconButton
          aria-label="close"
          size="small"
          onClick={onClose}
          sx={{ flexShrink: 0, p: 0 }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
}
